import * as React from 'react'
import { Icon } from 'semantic-ui-react'

export const FloatButton: React.SFC = () => {
  return(
    <a
      href="https://m.me/kuhau2103"
      target="_blank"
      style={{
      position: 'fixed',
      width: '200px',
      height: '30px',
      bottom: '10px',
      right: '40px',
      color: '#FFF',
      textAlign: 'center',
      backgroundColor: 'dodgerblue',
      boxShadow: '2px 2px 3px #999',
      fontSize: 'large',
      zIndex: 5
    }}
    >
      <Icon name="facebook f" style={{zIndex: 5}}/> <strong style={{zIndex: 5}}>Bạn muốn hỗ trợ?</strong>
    </a>
  )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/components/FloatButton.tsx